import { bootstrapRealtime } from '@/app/bootstrapRealtime'
import { APP_ROLE } from '@/config/env'
import { useDeliveryAddressStore } from '@/entities/delivery-address/model/useDeliveryAddressStore'
import { useInviteRefStore } from '@/entities/referral/model/useInviteRefStore'
import { useUtmStore } from '@/entities/utm/model/useUtmStore'
import { useCartStore } from '@/features/cart/model/useCartStore'
import { useClientOrdersStore } from '@/features/client-orders/model/useClientOrdersStore'
import { useAppStore } from '@/stores/app'
import { useAuthStore } from '@/stores/auth'

export async function bootstrapAuth({ initData, refCode } = {}) {
  const authStore = useAuthStore()
  const appStore = useAppStore()
  const inviteRefStore = useInviteRefStore()
  const utmStore = useUtmStore()

  inviteRefStore.restoreFromStorage()
  utmStore.restoreFromStorage()
  if (refCode) {
    inviteRefStore.setInviteRef(refCode)
  }

  await authStore.restoreSession()

  if (appStore.isTgApp && !authStore.isLoggedIn && initData) {
    try {
      await authStore.loginWithTelegram(initData, inviteRefStore.inviteRef)
    } catch (error) {
      console.warn('[auth] telegram login failed', error)
    }
  }

  authStore.validateRoleForApp(APP_ROLE)

  if (APP_ROLE === 'client' && !authStore.isLoggedIn) {
    useDeliveryAddressStore().restoreFromStorage()
  }

  if (authStore.isLoggedIn) {
    useDeliveryAddressStore().hydrateFromUser(authStore.user)

    if (APP_ROLE === 'client') {
      try {
        await useCartStore().syncFromServer()
      } catch (error) {
        console.warn('[cart] sync on bootstrap failed', error)
      }

      try {
        await useClientOrdersStore().loadActiveOrder()
        await bootstrapRealtime()
      } catch (error) {
        console.warn('[client-orders] bootstrap failed', error)
      }
    }

    if (APP_ROLE === 'restaurant' || APP_ROLE === 'courier') {
      try {
        await bootstrapRealtime()
      } catch (error) {
        console.warn('[realtime] bootstrap failed', error)
      }
    }
  }
}
